import { PAY_PACKAGES, BENEFITS } from "@/lib/data";
import { SectionHeading, Overline } from "@/components/Section";
import { CtaBanner } from "@/pages/Home";
import Stats from "@/components/Stats";
import SEOHead from "@/components/SEOHead";
import SettlementCalculator from "@/components/SettlementCalculator";

const TYPE_LABEL = {
  cpm: "¢ Per Mile",
  ppl: "Per Practical Load",
  percent: "Revenue Share",
  weekly: "Per Week",
  hourly: "Per Hour",
};

export default function PayBenefits() {
  return (
    <div data-testid="pay-benefits-page">
      <SEOHead
        title="Truck Driver Pay & Benefits | $1 CPM Team, 88% Lease Purchase"
        description="All 9 Hylas Companion pay packages: $1 CPM team driving, 85¢+ company CPM, 88% lease purchase revenue share, $2,500/wk local W2, $30/hr hourly. Full benefits — new trucks, weekly pay, flexible home time."
        keywords="truck driver pay, CPM rate, lease purchase revenue share, local driver weekly pay, truck driver benefits, OTR pay packages, company driver earnings"
        path="/pay-benefits"
      />
      <section className="pt-36 md:pt-44 pb-12 max-w-7xl mx-auto px-6 md:px-12">
        <Overline>Pay & Benefits</Overline>
        <h1 className="font-head text-4xl md:text-6xl font-bold uppercase tracking-[0.15em] mt-5 max-w-4xl leading-tight">
          Nine Ways To Earn
        </h1>
        <p className="mt-6 text-lg text-foreground/70 max-w-2xl">
          From $1 CPM team driving to local W2 and everything in between. Find the package that fits your life.
        </p>
      </section>

      {/* Pay Packages Grid */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {PAY_PACKAGES.map((pkg) => (
            <div
              key={pkg.id}
              data-testid={`pay-${pkg.id}`}
              className="bg-white p-8 md:p-10 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <span className="font-head text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                  {TYPE_LABEL[pkg.type] || pkg.type}
                </span>
                <span className="font-head text-[10px] uppercase tracking-[0.2em] bg-primary/10 text-primary px-2.5 py-1">
                  {pkg.badge}
                </span>
              </div>
              <div className="font-head text-4xl md:text-5xl font-bold text-[#0A0A0A] mt-2 leading-tight">
                {pkg.label}
              </div>
              <p className="font-head text-base uppercase tracking-[0.1em] mt-3 text-[#0A0A0A]/80">{pkg.title}</p>
              <p className="mt-3 text-sm text-foreground/60">{pkg.equipment}</p>
            </div>
          ))}
        </div>
        <p className="mt-4 text-sm text-muted-foreground">
          * Percentage packages calculated on a $3.50+ average per-mile base rate. Actual revenue may vary by load and route.
        </p>
      </section>

      <Stats />

      <SettlementCalculator />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <SectionHeading overline="More Than Pay" title="The Full Package" subtitle="Everything that keeps you rolling, comfortable, and home when it matters." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border mt-14 border border-border">
          {BENEFITS.map((b, i) => (
            <div key={b.title} className="bg-white p-8 md:p-10 hover:-translate-y-1 transition-transform duration-300">
              <span className="font-head text-xs tracking-[0.3em] text-primary">0{i + 1}</span>
              <h3 className="font-head text-xl uppercase tracking-[0.1em] mt-4">{b.title}</h3>
              <p className="mt-3 text-foreground/70 text-sm leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
